import axios from 'axios';

export const SET_CONFIG = 'SET_CONFIG';
export const setConfig = config => ({
	type: SET_CONFIG,
	payload: config
});

export const getConfig = () => dispatch => {
	const request = axios.get(`assets/config.json`);
	return request.then(res => dispatch(setConfig(res.data)));
};
